import { push } from 'connected-react-router';
import { getRedirectURLForEmailVerification } from 'Redux/profile/profileThunks';
import Routes from 'Routes/profileRoutes';

export const sendEmail = () => {
  return async dispatch => {
    const redirectURL = await dispatch(getRedirectURLForEmailVerification());
    if (redirectURL) {
      window.location = redirectURL;
    } else {
      dispatch(push(Routes.ROOT));
    }
  };
};
